import { TokenListMetadata } from "@bridgesplit/abf-sdk";
import { RouteStepType } from "@loopscale/pandora-types";
export interface SwapFormState {
    sellToken: TokenListMetadata | undefined;
    buyToken: TokenListMetadata | undefined;
    inputAmount: number | undefined;
    swapType: SwapType;
}

export enum SwapType { // Plume and other multistep swaps will have different swap types
    Swap = "Swap"
}

export interface ExchangeBadgeProps {
    exchangeName: RouteStepType;
    loading: boolean;
}
